module.exports = __webpack_public_path__ + "img/body.db46f5ce.png";